import {h, Component} from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import LFeed from "../../services/live-feed";

import SeamlessStats from "./components/seamless-stats";
import SoccerStatsTable from "./components/soccer-stats-table";
import Tracker from "./components/tracker";

import {DefaultWidgetNonSeamless, SoccerTimeline} from "./components/timeline";


export default class Widget extends Component {
	state = {
		showStats: true,
		showChart: true,
		showInfo: true,
	}
	// componentWillMount({stats = true, chart = true, info = true}) 
	componentWillMount() {
		LFeed.onUpdate(this.rerender = () => this.setState({}));
		this.setState({
			showStats: !!this.props.stats, 
			showChart: !!this.props.chart, 
			showInfo: !!this.props.info
		});
	}
	componentWillUnmount() {
		LFeed.stopUpdate(this.rerender);
	}
	render({eventId = '/event/0000000', isHorizontal = false, stats, chart, info}) {
        let event = LFeed.getEvent(eventId);
		
        if (!event) {
            return (
                <div class="error-event">
                    <Trans>Event has not started or wasn't found</Trans>
                </div>
            );
        }
		
		const eventStats = event.misc && event.misc.stats;
		
        return (<div class="softion-tracker">
	            <div class={"view " + (isHorizontal ? "h" : "v")}>
	                <div>{event.misc && event.misc.tracker && <Tracker event={event} />}</div>
	
	                <div>
	                    {isHorizontal && this.state.showInfo && !!eventStats && (
	                        <div>
	                            {event.sport == '/sport/1'
									? <SoccerTimeline event={event} /> 
									: <DefaultWidgetNonSeamless event={event} />}
	                        </div>
	                    )}
	                    <div class="animation-stat-tabs">
	                        <div
	                            onClick={() => this.setState({ showStats: !this.state.showStats })}
	                            class={"view-game-additional-info " + (this.state.showStats ? "active" : "")}
	                        >
	                            <Trans>H2H Chart</Trans>
	                        </div>
	                        <div
	                            onClick={() => this.setState({ showChart: !this.state.showChart })}
	                            class={"view-game-additional-info " + (this.state.showChart ? "active" : "")}
	                        >
	                            <Trans>Stats</Trans>
	                        </div>
	                        {!isHorizontal && (
	                            <div
	                                onClick={() => this.setState({ showInfo: !this.state.showInfo })}
	                                class={"view-game-additional-info " + (this.state.showInfo ? "active" : "")}
	                            >
	                                <Trans>Info</Trans>
	                            </div>
	                        )}
	                    </div>
	
	                    {this.state.showStats && !!eventStats && <SeamlessStats event={event} />}
	
	                    {this.state.showChart && !!eventStats && <SoccerStatsTable event={event} />}
	
	                    {!isHorizontal && this.state.showInfo && event.misc && event.misc.stats && (
	                        <div>
	                            {event.sport == '/sport/1' ? <SoccerTimeline event={event} /> : <DefaultWidgetNonSeamless E={event} />}
	                        </div>
	                    )}
	                </div>
	            </div>
			<div style="clear: both"></div>
            </div>
        );
    }
}